module.exports = __webpack_public_path__ + "img/icon_house.4002bc1.svg";